// Centralized dimensions configuration for Asset Image Editor
// All viewport, canvas, and Canva design dimensions are defined here

export interface DimensionConfig {
  width: number;
  height: number;
}

export interface AspectRatioDimensions {
  single: DimensionConfig;
  'side-by-side': DimensionConfig;
  stacked: DimensionConfig;
}

export interface LayoutDimensions {
  gap: number;
  padding: number;
  borderWidth: number;
  containerPadding: number;
}

// Viewport dimensions for dashed rectangles in the editor
export const VIEWPORT_DIMENSIONS: Record<string, AspectRatioDimensions> = {
  '1:1': {
    single: { width: 600, height: 600 },
    'side-by-side': { width: 350, height: 550 },
    stacked: { width: 768, height: 432 }
  },
  '16:9': {
    single: { width: 746, height: 420 },
    'side-by-side': { width: 746, height: 420 },
    stacked: { width: 1024, height: 576 }
  },
  '9:16': {
    single: { width: 295, height: 525 },
    'side-by-side': { width: 295, height: 525 },
    stacked: { width: 295, height: 525 }
  },
  '4:3': {
    single: { width: 759, height: 569 },
    'side-by-side': { width: 759, height: 569 },
    stacked: { width: 759, height: 569 }
  },
  'default': {
    single: { width: 525, height: 525 },
    'side-by-side': { width: 525, height: 525 },
    stacked: { width: 525, height: 525 }
  }
};

// Layout configuration for spacing and positioning
export const LAYOUT_CONFIG: LayoutDimensions = {
  gap: 50,                    // Gap between images in dual view modes
  padding: 16,                // Container padding
  borderWidth: 2,             // Dashed border thickness
  containerPadding: 50        // Top and bottom padding for canvas area
};

// Default fallback dimensions
export const DEFAULT_DIMENSIONS: DimensionConfig = {
  width: 500,
  height: 500
};

// Helper functions to get dimensions
export const getViewportDimensions = (
  aspectRatio: string, 
  viewMode: 'single' | 'side-by-side' | 'stacked'
): DimensionConfig => {
  const config = VIEWPORT_DIMENSIONS[aspectRatio] || VIEWPORT_DIMENSIONS['default'];
  return config[viewMode];
};

export const getCanvaDimensions = (
  aspectRatio: string, 
  viewMode: 'single' | 'side-by-side' | 'stacked'
): DimensionConfig => {
  const config = VIEWPORT_DIMENSIONS[aspectRatio] || VIEWPORT_DIMENSIONS['default'];
  return config[viewMode];
};

export const getLayoutConfig = (): LayoutDimensions => {
  return LAYOUT_CONFIG;
};